import { ChangePasswordValidator, ValidationChangePasswordOptions } from "approot/global/components/changepassword/changepassword.validator";
import { ChangePasswordData } from "approot/global/components/changepassword/common.changepassword.service";
import { ExternalChangePasswordRepository } from "./external.change.password.repository";
import * as md5r from "webroot/static/src/pages/users/js/md5r.js";
let md5 : (pass: string) => string = (<any>md5r).default;

class ExternalChangePasswordController {
	private jwtKey: string;

	public changed: boolean;

	public options: ValidationChangePasswordOptions;
	public validator: ChangePasswordValidator;
	public form: ng.IFormController;

	public ready: boolean;
	public readOnly: boolean;

	public error: boolean;
	public errorMessage: string;

	/*@ngInject*/
	constructor(
		private externalChangePasswordRepository: ExternalChangePasswordRepository,
		private $location: ng.ILocationService,
		public language
	) {
		let searchParams = this.$location.search();
		this.jwtKey = searchParams.jwtKey;

		this.externalChangePasswordRepository.jwtTokenValidate(this.jwtKey)
			.then(() => this.load())
			.catch((response) => this.handleError(response));
	}

	handleError(response) {
		this.error = true;
		this.errorMessage = response.data && (response.data.message || response.data.details);
		this.ready = true;
	}

	load() {
		this.externalChangePasswordRepository.getChangePasswordData(this.jwtKey)
			.then((data) => {
				this.fillOptions(data);
				this.validator = new ChangePasswordValidator(this.options);
				this.ready = true;
			});
	}

	fillOptions(data: ChangePasswordData) {
		this.options = {
			loginName:	data.loginName,
			lastName:	data.lastName,
			firstName:	data.firstName,
			middleName: data.middleName,
			oldPassword: null,
			newPassword: null,
			confirmPassword: null,
			userEditHimself: false,
			minPasswordLength: data.minPasswordLength,
			restrictNumericPasswords: data.restrictNumericPasswords
		};
	}

	// валидирует пароль
	runStartEndValidator() {
		if (this.options.newPassword) {
			this.form.newPassword.$setValidity("passLength",			!this.validator.checkNewPasswordLessLength());
			this.form.newPassword.$setValidity("passSimple",			!this.validator.checkNewPasswordSimple());
			this.form.newPassword.$setValidity("passNumeric",			!this.validator.checkNewPasswordNumeric());
			this.form.newPassword.$setValidity("passSurroundSpaces",	!this.validator.checkNewPasswordSurroundSpaces());
		}

		if (this.options.confirmPassword) {
			this.form.confirmPassword.$setValidity("passDifferent",		!this.validator.checkDifferentPassword());
		}
	}

	enter() {
	}

	save() {
		this.runStartEndValidator();
		if (this.form.$invalid) {
			this.form.$displayErrors = true;
			return;
		}

		this.ready = false;
		let password = md5(this.options.newPassword);
		this.externalChangePasswordRepository.changePassword(this.jwtKey, password)
			.then(() => this.changed = true)
			.catch((response) => this.handleError(response))
			.finally(() => this.ready = true);
	}

	toLogin() {
		this.$location.path("/authorize/login");
	}
}

export const ExternalChangePasswordComponent = {
	controller: ExternalChangePasswordController,
	controllerAs: "$ctrl",
	templateUrl: `/static/dist/app/login/external/external.change.password.component.html`
}